module.exports = __webpack_public_path__ + "img/value.7f8f3b61.png";